/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AerialImagesListCenter } from './AerialImagesListCenter';
import {
    AerialImagesListCenterFromJSON,
    AerialImagesListCenterFromJSONTyped,
    AerialImagesListCenterToJSON,
    AerialImagesListCenterToJSONTyped,
} from './AerialImagesListCenter';

/**
 * Serializer used by map views that retrieve AerialImage information.
 * @export
 * @interface AerialImagesList
 */
export interface AerialImagesList {
    /**
     * 
     * @type {string}
     * @memberof AerialImagesList
     */
    readonly id: string;
    /**
     * 
     * @type {string}
     * @memberof AerialImagesList
     */
    site?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof AerialImagesList
     */
    takenAt: Date;
    /**
     * 
     * @type {string}
     * @memberof AerialImagesList
     */
    tiledImage: string;
    /**
     * 
     * @type {string}
     * @memberof AerialImagesList
     */
    originalImage: string;
    /**
     * 
     * @type {AerialImagesListCenter}
     * @memberof AerialImagesList
     */
    center?: AerialImagesListCenter | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof AerialImagesList
     */
    readonly bounds: Array<number>;
    /**
     * 
     * @type {boolean}
     * @memberof AerialImagesList
     */
    isTiled?: boolean;
}

/**
 * Check if a given object implements the AerialImagesList interface.
 */
export function instanceOfAerialImagesList(value: object): value is AerialImagesList {
    if (!('id' in value) || value['id'] === undefined) return false;
    if ((!('takenAt' in (value as Record<string, any>)) && !('taken_at' in (value as Record<string, any>))) || ((value as Record<string, any>)['takenAt'] === undefined && (value as Record<string, any>)['taken_at'] === undefined)) return false;
    if ((!('tiledImage' in (value as Record<string, any>)) && !('tiled_image' in (value as Record<string, any>))) || ((value as Record<string, any>)['tiledImage'] === undefined && (value as Record<string, any>)['tiled_image'] === undefined)) return false;
    if ((!('originalImage' in (value as Record<string, any>)) && !('original_image' in (value as Record<string, any>))) || ((value as Record<string, any>)['originalImage'] === undefined && (value as Record<string, any>)['original_image'] === undefined)) return false;
    if (!('bounds' in value) || value['bounds'] === undefined) return false;
    return true;
}

export function AerialImagesListFromJSON(json: any): AerialImagesList {
    return AerialImagesListFromJSONTyped(json, false);
}

export function AerialImagesListFromJSONTyped(json: any, ignoreDiscriminator: boolean): AerialImagesList {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'site': json['site'] === undefined ? undefined : json['site'] === null ? null : json['site'],
        'takenAt': (new Date(json['taken_at'])),
        'tiledImage': json['tiled_image'],
        'originalImage': json['original_image'],
        'center': json['center'] === undefined ? undefined : json['center'] === null ? null : AerialImagesListCenterFromJSON(json['center']),
        'bounds': json['bounds'],
        'isTiled': json['is_tiled'] == null ? undefined : json['is_tiled'],
    };
}

export function AerialImagesListToJSON(json: any): AerialImagesList {
    return AerialImagesListToJSONTyped(json, false);
}

export function AerialImagesListToJSONTyped(value?: Omit<AerialImagesList, 'id'|'bounds'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'site': value['site'],
        'taken_at': value['takenAt'].toISOString().substring(0,10),
        'tiled_image': value['tiledImage'],
        'original_image': value['originalImage'],
        'center': AerialImagesListCenterToJSON(value['center']),
        'is_tiled': value['isTiled'],
    };
}

